// Header Navigation
//
// Manages the header nav toggle states:
// - Mobile hamburger menu
// - Dropdown groups (only one open at a time)
// - Search panel
//
// Rules:
// - Only one dropdown can be open at a time
// - Search and dropdowns are mutually exclusive
// - On mobile, opening search closes the mobile menu and any open dropdown
// - Opening the mobile menu closes search and any open dropdown
//
// uses:
// - Alpine.js (https://alpinejs.dev/start-here)
// - @alpinejs/collapse (https://alpinejs.dev/plugins/collapse)

(function () {
  document.addEventListener('alpine:init', () => {
    Alpine.data('headerNav', () => ({
      // State
      isMobileMenuOpen: false,
      activeDropdownId: null,
      isSearchOpen: false,
      isDesktop: false,

      // Actions

      // Toggle a dropdown group. Closes search if open.
      // If the same dropdown is already open, closes it.
      toggleDropdown(id) {
        this.isSearchOpen = false;
        this.activeDropdownId = this.activeDropdownId === id ? null : id;
      },

      // Toggle search panel. Closes any open dropdown and mobile menu.
      openSearch() {
        this.activeDropdownId = null;
        this.isMobileMenuOpen = false;
        this.isSearchOpen = !this.isSearchOpen;
        if (this.isSearchOpen) {
          this.$nextTick(() => {
            var input = this.$refs.searchInput;
            if (input) input.focus();
          });
        }
      },

      // Toggle mobile hamburger menu. Closes search and any open dropdown.
      toggleMobileMenu() {
        this.isSearchOpen = false;
        this.activeDropdownId = null;
        this.isMobileMenuOpen = !this.isMobileMenuOpen;
      },

      // Close everything
      closeAll() {
        this.isMobileMenuOpen = false;
        this.activeDropdownId = null;
        this.isSearchOpen = false;
      },

      // Alpine init
      init() {
        // Track desktop breakpoint (sm breakpoint = 56.25em / 900px)
        var smBreakpoint = window.matchMedia('(min-width: 56.25em)');
        this.isDesktop = smBreakpoint.matches;
        smBreakpoint.addEventListener('change', (e) => {
          this.isDesktop = e.matches;
          if (e.matches) {
            this.closeAll();
          }
        });
      },

      // Bindings
      closeAllDropdownHandler: {
        ['x-on:keydown.escape.window']() {
          this.closeAll();
        },
        ['x-on:click.outside'](event) {
          // If clicking a trigger button inside the header, let that trigger's handler execute
          if (event.target.closest && event.target.closest('button')) {
            return;
          }
          this.closeAll();
        },
      },

      searchTriggerHandler: {
        ['x-bind:aria-label']() {
          return this.isSearchOpen ? 'Close search' : 'Open search';
        },
        ['x-bind:aria-expanded']() {
          return this.isSearchOpen;
        },
        ['x-on:click']() {
          this.openSearch();
        },
      },

      searchToggleHandler: {
        ['x-show']() {
          return this.isSearchOpen;
        },
        ['x-on:transitionend'](event) {
          if (this.isSearchOpen && event.propertyName === 'height') {
            if (this.$refs.searchInput) this.$refs.searchInput.focus();
          }
        },
      },

      mobileMenuTriggerHandler: {
        ['x-bind:aria-label']() {
          return this.isMobileMenuOpen ? 'Close menu' : 'Open menu';
        },
        ['x-bind:aria-expanded']() {
          return this.isMobileMenuOpen;
        },
        ['x-on:click']() {
          this.toggleMobileMenu();
        },
      },

      mobileMenuToggleHandler: {
        ['x-show.immediate']() {
          return this.isMobileMenuOpen || this.isDesktop;
        },
      },

      dropdownMenuTriggerHandler(id) {
        return {
          ['x-bind:aria-expanded']() {
            return this.activeDropdownId === id;
          },
          ['x-on:click']() {
            this.toggleDropdown(id);
          },
        };
      },

      dropdownMenuHandler(id) {
        return {
          ['x-show']() {
            return this.activeDropdownId === id;
          },
        };
      },
    }));
  });
})();
